import { Observable, Subscription } from 'rxjs';

function toPromise<T>(
  observable: Observable<T>,
  resolveCondition?: (data: T) => boolean,
): Promise<T> {
  return new Promise((resolve, reject) => {
    let subscription: Subscription;
    subscription = observable.subscribe((data) => {
      if (!resolveCondition || resolveCondition(data)) {
        if (subscription) {
          // TODO: fix videoMaker mock to return subscription
          subscription.unsubscribe();
        }

        resolve(data);
      }
    }, reject);
  });
}

export default toPromise;
